module.exports = function (fox) {
	'use strict';
	fox.registerWidget('Page_CCPA_Site', {
		configure() {
			this.registerOptions('', {
				widgets: {
					popup: {
						widget: 'Popup_Common',
						useUiPosition: true,
						dialog: {
							title: 'California Consumer Privacy form',
							width: '550px',
							'!dialogClass': 'ccpa-form mc-site-common-popup gdpr-popup'
						},
						widgets: {
							content: {
								template: 'ccpa_form_site',
								widget: 'CCPR_Form',
							}
						}
					},
					popupSuccess: {
						widget: 'Popup_Common',
						useUiPosition: true,
						dialog: {
							title: 'Success',
							width: '320px',
							'!dialogClass': 'ccpa-form mc-site-common-popup gdpr-popup'
						},
						widgets: {
							content: {
								widget: 'Widget',
								template: 'ccpa_success_site',
								handleDom: {
									closePopup: {
										target: '.cancel-close, #success',
										event: 'click',
										callback : '@parent @parent:successHide'
										
									}
								}
							}
						}
					}
				},
				handleWom: {
					success: {
						widget: '#popup #content',
						event: 'form_submit_success',
						callback: 'hidePopup',
					},
					getMember: {
						widget: '@this',
						event: 'addedToDom',
						callback: 'getAutorized',
					}
				}
			});
			this.callParent('configure', arguments);
		},
		activating: function () {
			var name = window.location.hostname;
			this.setTemplateOptions('siteName', name);
			this.run();
		},
		successHide(){
			this.wom1('#popupSuccess').hide();
		},
		showPopup() {
				this.wom1('#popup').show();
		},
		hidePopup() {
			this.wom1('#popup').hide();
			this.wom1('#popupSuccess').show();
		},
		getAutorized() {
			const pm = this.rwom1('@root #permissionManager');
			const w = this.rwom1('#popup #content');
			if (pm.hasAccess('free') || pm.hasAccess('member')){
				w.setTemplateOptions('nomail', 1);
				w.render()
			}
		}
		
	}, 'Page_CCPA');
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/ccpa.es.js